// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"300":"b1bbfe46","313":"a701ab37","786":"e8118f96","960":"a0196617"}[chunkId] + ".css";
};